import { ActionQueue } from './ActionQueue';
import { debug } from './Miscellaneous';

const ActionQueueExport = {
    New: ActionQueue.New,
    debug: debug,
};

export { ActionQueueExport as ActionQueue };

export { Priority } from './Miscellaneous';
